import Modal, {Content, SimpleFooter, Header, SimpleButtonRow} from "ui-components-rollup/dist/Modal";
import {useDispatch, useSelector} from "react-redux";
import {Link} from "react-router-dom";
import React, { useState } from "react";
import ExternalLink from "components/ExternalLink";
import buttons from "ui-components-rollup/src/components/buttons.module.scss";
import {Toggle} from "ui-components-rollup/dist/Forms";

export default () => {
    const dispatch = useDispatch();
    const update = useSelector( state => state.currentConnector.updateVersions[0]);
    const autoUpgrade = useSelector( state => state.currentConnector.autoUpgrade);
    const [newAutoUpgrade, setNewAutoUpgrade] = useState(false);

    return <Modal>
        <Header>
            Software Update
        </Header>
        <Content>
            <p>Cloud Manager {update.name.split('-')[1]} Build: {update.releaseNumber} is now available.</p>
            <p>Would you like to update Cloud Manager to this version?</p>
            <p>
                <ExternalLink trackCategory="CurrentConnector" href="https://docs.netapp.com/us-en/occm/reference_new_occm.html" newTab>What’s new in this release?</ExternalLink>
            </p>
            {!autoUpgrade && <Toggle value={newAutoUpgrade} toggle={setNewAutoUpgrade}> Automatically update to the newest version</Toggle>}
        </Content>
        <SimpleFooter>
            <SimpleButtonRow>
                <button className={buttons.textSecondary} style={{margin: "0 auto 0 0"}} onClick={() => {
                    dispatch({
                        type: "CURRENT-CONNECTOR:HIDE-UPDATES-AVAILABLE",
                        payload: {
                            permanent: update.name
                        },
                        track: "never"
                    })
                }}>Don't show again</button>
                <Link to="/connector-settings/software-update" className={buttons.primary} style={{width: 152}} onClick={() => {
                    dispatch({
                        type: "CURRENT-CONNECTOR:HIDE-UPDATES-AVAILABLE",
                        track: "update"
                    })

                    if(newAutoUpgrade) {
                        dispatch({
                            type: "CURRENT-CONNECTOR:UPDATE-CONFIG",
                            payload: {
                                autoUpgrade: true
                            },
                            track: `autoUpgrade:true`
                        })
                    }
                }}>Update</Link>
                <button className={buttons.secondary} style={{width: 152}} onClick={() => {
                    dispatch({
                        type: "CURRENT-CONNECTOR:HIDE-UPDATES-AVAILABLE",
                        track: "not-now"
                    })
                }}>Not Now</button>
            </SimpleButtonRow>
        </SimpleFooter>
    </Modal>;
}
